export default "__VITE_ASSET__Dx95MrHr__"